import { render, staticRenderFns } from "./ValidConfigTable.vue?vue&type=template&id=5166f411"
import script from "./ValidConfigTable.vue?vue&type=script&lang=js"
export * from "./ValidConfigTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports